export const appState: any = {
    formData: null,
    completed: false,
    estimateDetails: null,
    content: {
        agentInfo: null,
    },
    isDemo: false,
    unlocked: false,
    questions: null,
    appAuthId: null,
    appId: null,
    illustrationUploadId: null,
    prefillValues: false,
    payloadQueue: [],
    activeSubmission: false,
    simulate: null,
    userRole: {
        name: 'Agent',
        id: 1,
        customerSigned: 0
    },
    decisionInfo: null,
    expired: false
};

// question types using custom components
export const customFormTypes = ['Name', 'Address', 'Length', 'BloodPressure', 'Physician', 'File'];

// questions using custom components
export const customFormNames = ['SignatureBase'];

// questions excluded from display
// PolicyCreateDate is automatically populated
export const skippedQuestions = ['PolicyCreateDate', 'ApplicantRole'];

// TODO: skip validation for custom forms and types
// arrays
export const skipValidationFields = ['SecondaryAddresseeName'];

// ReplacementInsurance has special validators
export const exemptFromValidation = ['ReplacementInsurance'];

// Insurance Inforce
export const allowedReplacement = ['AL', 'AZ', 'AR', 'CA', 'CO', 'CT', 'HI', 'IA', 'KY', 'LA', 'ME', 'MS', 'NE', 'NH', 'NJ', 'NM', 'NC', 'OH', 'OR', 'SC', 'SD', 'TX', 'UT', 'VT', 'WV', 'WI'];

// NAIC eligibleStates
export const eligibleStates = ['AL', 'AZ', 'AR', 'CO', 'CT', 'HI', 'IA', 'KY', 'LA', 'ME', 'MS', 'NE', 'NH', 'NJ', 'NM', 'NC', 'OH', 'OR', 'SC', 'SD', 'TX', 'UT', 'VT', 'WV', 'WI'];
